var map = {
	"./black/hujiao.png": "01+5",
	"./blue/hujiao.png": "endb",
	"./white/hujiao.png": "Hza3"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "jzOI";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bottom ^\.\/.*\/hujiao\.png$
// module id = jzOI
// module chunks = 24